import "../Script/_shared/index"
import "../Script/default/index"
import "../Style/default/index.scss"